// LandingPage.jsx

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../index.css";
import { trackFunnelStepComplete, trackFunnelStepView } from "../utils/analytics";

function LandingPageScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    trackFunnelStepView(1, "landing_screen");
  }, []);

  const handleStartValuation = () => {
    trackFunnelStepComplete(1, "landing_screen");

    localStorage.setItem("type", "Operating/Stabilized");
    navigate("/region-selection");
  };

  return (
    <div className="landing-shell">
      <section className="landing-hero">
        <section className="brand" aria-label="Skyward valuation">
          <img
            className="brand-logo-full"
            src={`${process.env.PUBLIC_URL}/skyward-logo.svg`}
            alt="Skyward Innovation"
          />
          <div>
            <p className="brand-tagline">
              Preliminary hotel valuation intake
            </p>
          </div>
        </section>

        <div className="landing-copy">
          <h1>Your Hotel Valuation Tool</h1>
          <p className="subtitle">
            Generate a preliminary hotel valuation range from location,
            property characteristics, operating inputs, and future potential.
          </p>
          <p className="helper">
            This free tool is for informational and discussion purposes only.
            It is not a formal appraisal and does not provide financial, legal,
            tax, or investment advice. Professional review is recommended
            before relying on any valuation results.
          </p>
        </div>

        <div className="landing-actions">
          <button className="button" onClick={handleStartValuation}>
            Start Valuation
          </button>
          <a className="button secondary-button" href="/terms-of-service">
            Terms of Service
          </a>
        </div>
      </section>

      <section className="partner-section">
        <h2 className="section-title">Trusted Partners</h2>
        <div className="partner-container">
          <a
            href="https://www.partner1website.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/gwwfinal.png" alt="Partner 1" className="partner-logo" />
          </a>

          <a
            href="https://redrones.ie"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/REDRONES_LOGO2.png"
              alt="Redrones"
              className="partner-logo"
            />
          </a>

          <a
            href="https://failteabhaile.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/foundation_logo3.png"
              alt="Failteabhaile"
              className="partner-logo"
            />
          </a>

          <a
            href="https://skyprop.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/SkyProp_logoDraft3.png"
              alt="skyprop"
              className="partner-logo"
            />
          </a>

          <a
            href="https://kaizenstrategic.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/kaizen_logo.png" alt="kaizen" className="partner-logo" />
          </a>
        </div>
      </section>

      <footer className="site-footer">
        <p>&copy; 2024 Skyward Innovation, a DRPY Ltd business. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default LandingPageScreen;
